import type { MovementMuscleInfo } from '@az3fr/core';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

const movementMuscleAdapter = createEntityAdapter<MovementMuscleInfo, string>({
	selectId: (movementMuscle) => `${movementMuscle.movementId}-${movementMuscle.muscleId}`,
});
const movementMuscleSlice = createSlice({
	name: 'entities/movement-muscle',
	initialState: movementMuscleAdapter.getInitialState(),
	reducers: {
		setAll: movementMuscleAdapter.setAll,
	},
});
type MovementMuscleSliceState = ReturnType<typeof movementMuscleAdapter.getInitialState>;

const movementMuscleSliceActions = { ...movementMuscleSlice.actions };
const movementMuscleSliceReducer = movementMuscleSlice.reducer;

export { movementMuscleSliceActions, movementMuscleSliceReducer, movementMuscleAdapter };
export type { MovementMuscleSliceState };
